import { render, staticRenderFns } from "./ToggleModalOnlyForSmallScreen.vue?vue&type=template&id=8fe5bc6a&"
import script from "./ToggleModalOnlyForSmallScreen.vue?vue&type=script&lang=js&"
export * from "./ToggleModalOnlyForSmallScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports